import { useAppMutation } from '@alluradirect/react';

interface SendValues {
  password: string;
}

export const useRestauthUserPasswordUpdateMutation = () => {
  return useAppMutation<SendValues>({
    url: '/RESTAUTH/user/password/',
    method: 'PUT',
  });
};
